import React from 'react'
import LoginNavbar from './common/LoginNavbar'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col">
        <LoginNavbar />
      <main className="flex-1">
        {children}
      </main>
    </div>
  )
}

export default Layout